import {IBaseLookup} from "./Ibase.lookup";

export namespace PatientClass {

    export const lookupName: string = "PatientClass";

    export interface PatientClass {
        patientClassKey: number;
        code: string;
        description: string;
        scheduleSchemeKey: number;
        active: string;
        lastUpdated: Date;
    }

    export interface PatientClassDS extends IBaseLookup {
        patientClass: PatientClass[];
    }
}
